export default {
    "COBALT-COMPOUNDS":true,
    "ACRYLIC-ACID":true, 
    "QUINONE--P-BENZOQUINONE-":true, 
    "PHOSPHINE":true, 
    "BENZYL-CHLORIDE": true, 
    "ANTIMONY-COMPOUNDS": true,
}